import React, { FC } from "react";

import { Button } from "@at/design-system-elements";
import { TypeInsignia } from "@at/design-system-foundation";

import * as Styles from "./vehicle-summary-list.styled";
import { IVehicleSummaryListProps } from "./vehicle-summary-list.types";
import { setLeasingModal } from "../../contexts/leasing/actions/leasing.actions";
import { useLeasingDispatchContext } from "../../contexts/leasing/context/leasing.context";
import { LeasingModals } from "../../contexts/leasing/types/leasing.types";
import { useTracking } from "../../utils/tracking/use-tracking";
import DescriptionList from "../advert/overview/description-list";

export const VehicleSummaryList: FC<IVehicleSummaryListProps> = ({
  title,
  data,
}) => {
  const dispatch = useLeasingDispatchContext();

  const { trackEvent } = useTracking();
  const listTitle = title ?? "Vehicle summary";

  const handleOpenTechnicalSpec = () => {
    dispatch(
      setLeasingModal({
        show: true,
        type: LeasingModals.TECHNICAL_SPECIFICATIONS,
        title: "Technical specifications",
      }),
    );

    trackEvent({ trackingLabel: "features-spec-open-modal" });
  };

  return (
    <Styles.LeasingVehicleSummary>
      <TypeInsignia as="h3" weight="400">
        {listTitle}
      </TypeInsignia>
      <DescriptionList id="leasing-vehicle-summary" data={data} />
      <Button
        onInteraction={handleOpenTechnicalSpec}
        text="View all features and spec"
        displayType="secondary"
      />
    </Styles.LeasingVehicleSummary>
  );
};
